import { CommonGet, CommonPost, CommonGetIDServer } from "../../../utils/CommonFetch";
import tokenDecoder from '../../../components/Common/tokenDecoder';

export default {
    getGroups,
    getEstatesByGroupID,
    syncData,
    getSyncedData,
    getDivisions
};
async function syncData(data) {
    const formData = {
        estateID: parseInt(data.operationEntityID),
        date: (data.date),
        divisionID: parseInt(data.divisionID),
        transactionTypeID: parseInt(data.transactionTypeID),
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
    }
    var result = await CommonPost('/api/SyncTransactions/Sync', null, formData);
    return result;
}

async function getEstatesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupId=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return array;
}

async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}


async function getDivisions(estateID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateId=' + estateID);
    let array = []
    for (let item of Object.entries(response.data)) {

        array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]

    }
    return array;
}

async function getSyncedData(model) {
    var response = await CommonPost('/api/SyncTransactions/GetSyncedTransactionDetails',null, model);
    return response.data;
}
